// crm-web/frontend/src/components/analytics/TabNav.jsx
// Navegacion horizontal de tabs. Filtra por adminOnly segun rol.

import { useAuth } from '../../hooks/useAuth'

export default function TabNav({ tabs, activeId, onChange }) {
  const { user } = useAuth()

  const visibleTabs = tabs.filter(t => !t.adminOnly || user?.is_admin)

  return (
    <div className="flex items-center gap-1 border-b border-gray-200 dark:border-gray-700 mb-4">
      {visibleTabs.map(tab => {
        const isActive = tab.id === activeId
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg transition relative ${
              isActive
                ? 'text-primary-600 dark:text-primary-400 bg-white dark:bg-gray-800'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800/50'
            }`}
          >
            {tab.label}
            {isActive && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500 dark:bg-primary-400" />
            )}
          </button>
        )
      })}
    </div>
  )
}
